import listActions from './listActions';

const emailActions = {};

emailActions.sendEmailStart = () => ({type: listActions.SEND_EMAIL_START});

emailActions.sendEmailSuccess = () => ({type: listActions.SEND_EMAIL_SUCCESS});

emailActions.sendEmailFail = () => ({type: listActions.SEND_EMAIL_FAIL});

export default emailActions;



// WEBPACK FOOTER //
// ./src/store/actions/emailActions.js